import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isNil } from '@pct-ts/typeguard';

@Pipe({
  name: 'isDisabledClearButton',
})
export class IsDisabledClearButtonPipe implements PipeTransform {
  transform(value: unknown): boolean {
    return isNil(value) || (Array.isArray(value) && value.length === 0);
  }
}
